"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("../../../../config.json"));

var RaiseNewProblem = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(RaiseNewProblem, _Component);

  var _super = (0, _createSuper2.default)(RaiseNewProblem);

  function RaiseNewProblem() {
    var _this;

    (0, _classCallCheck2.default)(this, RaiseNewProblem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      cl: localStorage.getItem("CL"),
      problem: "",
      details: ""
    };

    _this.onChange = function (e) {
      _this.setState({
        problem: e.target.value
      });
    };

    _this.onDetail = function (e) {
      _this.setState({
        details: e.target.value
      });
    };

    _this.onFileChange = function (event) {
      _this.setState({
        image: event.target.files[0]
      });
    };

    _this.onFileUpload = function () {
      // Create an object of formData
      var formData = new FormData(); // Update the formData object

      formData.append("myFile", _this.state.selectedFile, _this.state.selectedFile.name); // Details of the uploaded file

      console.log(_this.state.selectedFile); // Request made to the backend api
      // Send formData object

      _axios.default.post("api/uploadfile", formData);
    };

    _this.submit = function (e) {
      var cl = localStorage.getItem("CL");
      var data = {
        clcode: cl,
        problem: _this.state.problem,
        details: _this.state.details
      };
      var url = _config.default.problemform + _this.state.cl;

      _axios.default.post(url, data).then(function (resp) {
        window.location = '/clPortal/app/home';
      }, function (error) {
        console.log(error);
      });
    };

    return _this;
  }

  (0, _createClass2.default)(RaiseNewProblem, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          cl = _this$state.cl,
          problem = _this$state.problem;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
        style: {
          backgroundColor: "lightgrey"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/_react.default.createElement("h1", null, " CL code :", cl, " ")), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          color: "black"
        }
      }, /*#__PURE__*/_react.default.createElement("b", null, "\u0915\u094D\u092F\u093E \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0906 \u0930\u0939\u0940 \u0939\u0948?:"), /*#__PURE__*/_react.default.createElement(_antd.Radio.Group, {
        onChange: this.onChange,
        value: problem,
        className: "m-2 p-2"
      }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
        direction: "vertical"
      }, /*#__PURE__*/_react.default.createElement(_antd.Radio, {
        value: "पैरेंट डेटाबेस में प्रॉब्लम है।",
        style: {
          color: "black"
        }
      }, "\u092A\u0948\u0930\u0947\u0902\u091F \u0921\u0947\u091F\u093E\u092C\u0947\u0938 \u092E\u0947\u0902 \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
        value: "एनरोलमेंट फॉर्म  में प्रॉब्लम है।",
        style: {
          color: "black"
        }
      }, "\u090F\u0928\u0930\u094B\u0932\u092E\u0947\u0902\u091F \u092B\u0949\u0930\u094D\u092E  \u092E\u0947\u0902 \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
        value: "ड्रॉपआउट  फॉर्म  में प्रॉब्लम है।",
        style: {
          color: "black"
        }
      }, "\u0921\u094D\u0930\u0949\u092A\u0906\u0909\u091F  \u092B\u0949\u0930\u094D\u092E  \u092E\u0947\u0902 \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
        value: "बैकअप / पर्जिंग   में प्रॉब्लम है।",
        style: {
          color: "black"
        }
      }, "\u092C\u0948\u0915\u0905\u092A / \u092A\u0930\u094D\u091C\u093F\u0902\u0917   \u092E\u0947\u0902 \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
        value: "ऑडिट फॉर्म में प्रॉब्लम है।",
        style: {
          color: "black"
        }
      }, "\u0911\u0921\u093F\u091F \u092B\u0949\u0930\u094D\u092E \u092E\u0947\u0902 \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
        value: "RM Rubric फॉर्म में प्रॉब्लम है।",
        style: {
          color: "black"
        }
      }, "RM Rubric \u092B\u0949\u0930\u094D\u092E \u092E\u0947\u0902 \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0939\u0948\u0964  "), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
        value: "अटेंडेंस में  प्रॉब्लम है।",
        style: {
          color: "black"
        }
      }, "\u0905\u091F\u0947\u0902\u0921\u0947\u0902\u0938 \u092E\u0947\u0902  \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
        value: "RM रेटिंग  में  प्रॉब्लम है।",
        style: {
          color: "black"
        }
      }, "RM \u0930\u0947\u091F\u093F\u0902\u0917  \u092E\u0947\u0902  \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
        value: "इन्वेंटरी में प्रॉब्लम है।",
        style: {
          color: "black"
        }
      }, "\u0907\u0928\u094D\u0935\u0947\u0902\u091F\u0930\u0940 \u092E\u0947\u0902 \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0939\u0948\u0964"), /*#__PURE__*/_react.default.createElement(_antd.Radio, {
        value: "कोई अन्य प्रॉब्लम है।",
        style: {
          color: "black"
        }
      }, "\u0915\u094B\u0908 \u0905\u0928\u094D\u092F \u092A\u094D\u0930\u0949\u092C\u094D\u0932\u092E \u0939\u0948\u0964"))), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
        name: "",
        label: "",
        className: "mt-3 pt-3",
        style: {
          color: "black"
        }
      }, /*#__PURE__*/_react.default.createElement("b", null, "\u092A\u094D\u0930\u094B\u092C\u094D\u0932\u094D\u0935\u094D\u092E \u0915\u094B \u092A\u0942\u0930\u093E \u0921\u093F\u091F\u0947\u0932 \u092E\u0947\u0902 \u0932\u093F\u0916\u093F\u090F : "), /*#__PURE__*/_react.default.createElement(_antd.Input, {
        onChange: this.onDetail
      })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
        name: "",
        label: "",
        style: {
          color: "black"
        }
      }, /*#__PURE__*/_react.default.createElement("b", null, "\u0938\u094D\u0915\u094D\u0930\u0940\u0928\u0936\u0949\u091F \u0932\u0917\u093E\u0907\u090F"), /*#__PURE__*/_react.default.createElement("input", {
        type: "file",
        onChange: this.onFileChange,
        className: "btn btn-success m-1"
      }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
        onClick: this.onFileUpload,
        className: "btn btn-success",
        style: {
          backgroundColor: "lightgreen",
          color: "black"
        }
      }, "Upload")), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
        htmlType: "submit",
        onClick: this.submit,
        style: {
          backgroundColor: "skyblue",
          color: "black"
        }
      }, "Submit")))));
    }
  }]);
  return RaiseNewProblem;
}(_react.Component);

var _default = RaiseNewProblem;
exports.default = _default;